import { StateMachineState } from './types';
import * as React from 'react';

type FilterProcessingStateSetter = (state: StateMachineState) => void;
type FilterProcessingStateContextValues = [
  StateMachineState,
  FilterProcessingStateSetter,
];

const FilterProcessingStateContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<FilterProcessingStateContextValues>(null);

/**
 * @description A hook for reading and setting the filter processing state. We
 * use this to determine if we are processing the default filters or not.
 */
function useFilterProcessingState() {
  const context = React.useContext(FilterProcessingStateContext);

  if (!context) {
    throw new Error(
      'useFilterProcessingState must be used within a FilterProcessingStateContext',
    );
  }

  return context;
}

function FilterProcessingStateProvider(props: any) {
  const [filterProcessingState, setFilterProcessingState] =
    React.useState<StateMachineState>('INITIALIZING');

  const value = React.useMemo(
    () => [filterProcessingState, setFilterProcessingState],
    [filterProcessingState],
  );

  return <FilterProcessingStateContext.Provider value={value} {...props} />;
}

export { FilterProcessingStateProvider, useFilterProcessingState };
